import {
  DocumentTypeMatchingRecordAction,
  DocumentTypeConfigurationModel,
  DocumentTypeStoreConfigurationModel,
  ReferenceConfigurationModel
} from '@/types';
import { DocumentTypeEncryptionEnabledType } from '@/types/enums/DocumentTypeEncryptionEnabledType';

export const DocumentTypeConfigurationModelDefaults: DocumentTypeConfigurationModel = {
  id: null,
  isNew: true,
  modified: false,
  description: '',
  storeConfiguration: {
    matchExistingRecordAction: DocumentTypeMatchingRecordAction.CreateNew,
    clearReferencesAfterUpdate: true,
    documentDateIsLookupField: false,
    documentDateDescription: 'Document Date'
  } as DocumentTypeStoreConfigurationModel,
  referencesConfiguration: [] as ReferenceConfigurationModel[],
  encryptionEnabled: DocumentTypeEncryptionEnabledType.Disabled
};